import { useSectionHistoryTop } from 'weblite-router'
import { VisibilityHandler } from './components/visibility-handler'
import { PvCallManagerPage } from '$comp/pv-call-manager-page'
import { useHandleCallSounds } from '$logic/call'

export function PvCallManager() {
  const commSectionTop = useSectionHistoryTop('comm')
  useHandleCallSounds()

  return (
    <VisibilityHandler
      zIndex={1}
      style={{
        pointerEvents: commSectionTop !== 'pvCallManager' ? 'none' : 'auto',
      }}
    >
      <PvCallManagerPage />
    </VisibilityHandler>
  )
}
